type ProductName =
  | "Latitude Personal Loan"
  | "Gem Personal Loan"
  | "Buyer's Edge"
  | "LatitudePay"
  | "GenoaPay"
  | "Gem Better Start Personal Loan"
  | "Latitude Better Start Personal Loan"
  | "Latitude Low Rate Mastercard"
  | "Latitude Mastercard"
  | "GO Platinum Mastercard"
  | "Latitude Infinity Rewards Platinum Visa"
  | "Latitude Gem Visa"
  | "Latitude 28 Degrees Global Platinum Mastercard"
  | "CreditLine - Apple Financial Services"
  | "Latitude Infinity Rewards Visa"
  | "CreditLine"
  | "LatitudePay Plus"
  | "Gem Motor Loan"
  | "Gem Essential"
  | "GO Mastercard"
  | "Latitude Eco Mastercard"
  | "CareCredit"
  | "Gem Visa"
  | "Gem CreditLine";

export const legalMap: Record<ProductName, string> = {
  "Latitude Personal Loan": "",
  "Gem Personal Loan": "",
  "Buyer's Edge": "buyersedge",
  LatitudePay: "",
  GenoaPay: "",
  "Gem Better Start Personal Loan": "",
  "Latitude Better Start Personal Loan": "",
  "Latitude Low Rate Mastercard": "lowrate",
  "Latitude Mastercard": "latitude-mc",
  "GO Platinum Mastercard": "gomc-business",
  "Latitude Infinity Rewards Platinum Visa": "latitude-infinity",
  "Latitude Gem Visa": "gemvisa-au",
  "Latitude 28 Degrees Global Platinum Mastercard": "28degrees-au",
  "CreditLine - Apple Financial Services": "creditline-afs",
  "Latitude Infinity Rewards Visa": "latitude-infinity",
  CreditLine: "creditline-au",
  "LatitudePay Plus": "",
  "Gem Motor Loan": "",
  "Gem Essential": "GemEssential",
  "GO Mastercard": "gomc-au",
  "Latitude Eco Mastercard": "eco",
  CareCredit: "carecredit",
  "Gem Visa": "gemvisa-nz",
  "Gem CreditLine": "creditline-nz",
};

export const additionalCardHolderMap: Record<ProductName, string> = {
  "Latitude Personal Loan": "",
  "Gem Personal Loan": "",
  "Buyer's Edge": "",
  LatitudePay: "",
  GenoaPay: "",
  "Gem Better Start Personal Loan": "",
  "Latitude Better Start Personal Loan": "",
  "Latitude Low Rate Mastercard":
    "https://assets.latitudefinancial.com/forms/cards/additional-cardholder/lowratemc-addcard.pdf",
  "Latitude Mastercard":
    "https://assets.latitudefinancial.com/forms/cards/additional-cardholder/latitude-mc-addcard.pdf",
  "GO Platinum Mastercard": "",
  "Latitude Infinity Rewards Platinum Visa":
    "https://eform.latitudefinancial.com.au/eform/Page.do?eFormName=ACH_infinity",
  "Latitude Gem Visa":
    "https://eform.latitudefinancial.com.au/eform/Page.do?eFormName=ACH_gemau",
  "Latitude 28 Degrees Global Platinum Mastercard":
    "https://eform.latitudefinancial.com.au/eform/Page.do?eFormName=ACH_28degrees",
  "CreditLine - Apple Financial Services":
    "https://assets.latitudefinancial.com/forms/cards/additional-cardholder/latitude-addcard.pdf",
  "Latitude Infinity Rewards Visa":
    "https://eform.latitudefinancial.com.au/eform/Page.do?eFormName=ACH_infinity",
  CreditLine: "",
  "LatitudePay Plus": "",
  "Gem Motor Loan": "",
  "Gem Essential": "",
  "GO Mastercard":
    "https://eform.latitudefinancial.com.au/eform/Page.do?eFormName=ACH_gomc",
  "Latitude Eco Mastercard": "",
  CareCredit: "",
  "Gem Visa": "",
  "Gem CreditLine": "",
};
